<template>
	
	<v-card light elevation="5"> 

		<form @submit.prevent="changeEmail()" class="pa-5" id="change-email-form">

			<div class="text-center mb-3">
				<v-icon size="100">mdi-email</v-icon>
			</div>

			<v-text-field
        label="Correo actual"
        filled
        v-model="user.current_email"
        disabled
      ></v-text-field> 

      <v-text-field
      	type="email"
      	required
        label="Nuevo correo electrónico"
        filled
        v-model="user.new_email"
      ></v-text-field> 

      <v-btn type="submit" dark large block>
	      Cambiar correo
	    </v-btn>

		</form>

	</v-card>

</template>



<script>
	
	import UserService from '@/shared/services/UserService'


	export default
	{

		data() {
			return {
				user: {
					id: null,
					current_email: null,
					new_email: null
				}
			}
		},

		created() {
			this.getEmail()
		},

		methods: {

			async getEmail()
			{
				const resp = await UserService.getUser()
				this.user.id = resp.data.id
				this.user.current_email = resp.data.email
			},

			async changeEmail()
			{
				const resp = await UserService.changeEmail(this.user)

				console.log(resp.data)

				if(resp.data == 'OK')
				{
					SwalAlert('', 'Correo electrónico cambiado. Hemos enviado un link de verificación a: '+this.user.new_email, 'success')
					localStorage.removeItem('token')
					this.$router.push('/autenticacion/verificar-correo/'+this.user.new_email)
				}
				else if(resp.data == 'ERROR_EMAIL_EXIST')
					SwalAlert('', 'El correo electrónico que introdujiste ya se encuentra registrado', 'error')
				else
					SwalAlert('', 'Ha ocurrido un error, por favor intenta de nuevo', 'error')
			}

		}

	}

</script>